<template>
  <div class="flex gap-1">
    <div
      v-for="step in totalSteps"
      :key="step"
      class="h-1.5 flex-1 rounded-full"
      :class="step <= currentStep ? 'bg-primary' : 'bg-gray-300'"
    />
  </div>
</template>

<script>
export default {
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
    totalSteps: {
      type: Number,
      default: 4,
    },
  },
};
</script>
